module.exports = __webpack_public_path__ + "img/1522955009.c4ea0cad.jpg";